import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';
import { WindIconComponent } from 'src/app/side-panel/wind-card/wind-icon/wind-icon.component';

@Component({
  selector: 'app-wind-card',
  imports: [TextModule, AsyncPipe, PipesModule, DirectivesModule, WindIconComponent],
  templateUrl: './wind-card.component.html',
  styleUrl: './wind-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindCardComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);

  type = EnumMeasureTypes.WIND_STRENGTH;

  station = this.weathermapFacade.selectedStation;
  windStrength = computed(() => this.station().WindStrength?.[this.station().WindStrength?.length - 1].y ?? null);
  windAngle = computed(() => this.station().WindAngle?.[this.station().WindAngle?.length - 1].y ?? null);
  gustStrength = computed(() => this.station().GustStrength?.[this.station().GustStrength?.length - 1].y ?? null);
}
